export const pagePaths = {
	pageGuide: ["guides"],
	pageStandard: [""],
	pageVideoSeries: ["series"],
	pageReleaseNotes: ["updates"],
};
